import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isDrawerOpen: false,
  jid: null,
  upgradeMode: false,
};

const drawerSlice = createSlice({
  name: "drawer",
  initialState,
  reducers: {
    openDrawer: (state, action) => {
      state.isDrawerOpen = true;
      state.jid = action.payload || null;
      state.upgradeMode = false;
    },
    openDrawerUpgrade: (state, action) => {
      state.isDrawerOpen = true;
      state.jid = action.payload || null;
      state.upgradeMode = true;
    },
    closeDrawer: (state) => {
      state.isDrawerOpen = false;
      state.jid = null;
      state.upgradeMode = false;
    },
    toggleDrawer: (state, action) => {
      const jid = action.payload;
      if (state.isDrawerOpen) {
        state.isDrawerOpen = false;
        state.jid = null;
        state.upgradeMode = false;
      } else {
        state.isDrawerOpen = true;
        state.jid = jid || null;
        state.upgradeMode = false;
      }
    },
  },
});

export const { openDrawer, closeDrawer, toggleDrawer, openDrawerUpgrade } = drawerSlice.actions;
export default drawerSlice.reducer;
